/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FusionMelcoModelsThreadColor,
    FusionMelcoModelsThreadColorFromJSON,
    FusionMelcoModelsThreadColorFromJSONTyped,
    FusionMelcoModelsThreadColorToJSON,
} from './';

/**
 * 
 * @export
 * @interface FusionMelcoModelsColorListItem
 */
export interface FusionMelcoModelsColorListItem {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsColorListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsColorListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsColorListItem
     */
    code?: string | null;
    /**
     * 
     * @type {FusionMelcoModelsThreadColor}
     * @memberof FusionMelcoModelsColorListItem
     */
    color?: FusionMelcoModelsThreadColor;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsColorListItem
     */
    type?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FusionMelcoModelsColorListItem
     */
    weight_list?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsColorListItem
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsColorListItem
     */
    product_name?: string | null;
}

export function FusionMelcoModelsColorListItemFromJSON(json: any): FusionMelcoModelsColorListItem {
    return FusionMelcoModelsColorListItemFromJSONTyped(json, false);
}

export function FusionMelcoModelsColorListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsColorListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'color': !exists(json, 'color') ? undefined : FusionMelcoModelsThreadColorFromJSON(json['color']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'weight_list': !exists(json, 'weight_list') ? undefined : json['weight_list'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
    };
}

export function FusionMelcoModelsColorListItemToJSON(value?: FusionMelcoModelsColorListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'color': FusionMelcoModelsThreadColorToJSON(value.color),
        'type': value.type,
        'weight_list': value.weight_list,
        'supplier_name': value.supplier_name,
        'product_name': value.product_name,
    };
}


